import { render, staticRenderFns } from "./target-search-new.vue?vue&type=template&id=73223971&"
import script from "./target-search-new.vue?vue&type=script&lang=js&"
export * from "./target-search-new.vue?vue&type=script&lang=js&"
import style0 from "./target-search-new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports